"use strict"

import {VutBox} from './class.vutbox.js';

// bs5 modal fix !!!
window.addEventListener('focusin', event=>event.target?.closest?.('#vutbox-container') ? event.stopImmediatePropagation() : undefined, true);

(()=>{

    if (parent !== self) { // iframe !!
        self.VutBox = parent.VutBox;
        return;
    }

    let close;
    try {
        close=jstr("Zavřít");
    } catch(e) {
        close="Zavřít";
    }
    
    VutBox.init();
    
    window.VutBox={
        
        // instance vutbox dle id
        box:VutBox.box,

        // otevření boxu
        show:VutBox.show,
        open:VutBox.show,
        replace:VutBox.show,
        
        // dialog
        dialog:VutBox.dialog,

        // dialog
        grid:VutBox.grid,
        
        // alert
        alert:VutBox.alert,
                
        // zavření boxu
        hide:VutBox.hide,
        close:VutBox.hide,
        
        // resize
        resize:VutBox.resize,
        
        // obecně - je vidět NĚJAKÝ vutbox?
        get shown(){return VutBox.shown()},
        
        // předdefinované buttony pro dialog:        
        get CLOSE(){return {'class':'vutbox-close', name:close} },
        get OK(){return {'class':'vutbox-close', name:'OK'} },
        get CLOSE_FOCUS_ME(){return {'class':'vutbox-close focus-me', name:close} },
        get OK_FOCUS_ME(){return {'class':'vutbox-close focus-me', name:'OK'} },

        get CLOSE_PRIMARY(){return {'class':'vutbox-close btn-primary', name:close} },
        get OK_PRIMARY(){return {'class':'vutbox-close btn-primary', name:'OK'} },
        get CLOSE_PRIMARY_FOCUS_ME(){return {'class':'vutbox-close btn-primary focus-me', name:close} },
        get OK_PRIMARY_FOCUS_ME(){return {'class':'vutbox-close btn-primary focus-me', name:'OK'} },
        
    }

    Object.defineProperty(window.VutBox.grid, 'shown', {get:VutBox.gridShown});
    Object.defineProperty(window.VutBox.grid, 'focused', {get:VutBox.gridFocused});
    Object.defineProperty(window.VutBox.grid, 'resize', {value:VutBox.gridResize});
    
    try {
        
        VUTResizeHandler.add(VutBox.resize);
        window.addEventListener('resize', ()=>{
            if (VutBox.shown()) {
                document.documentElement.style.setProperty("--vutbox-scrollbar-width", (VutBox.container.offsetWidth - VutBox.container.clientWidth) + 'px');
            } else {
                document.documentElement.style.removeProperty("--vutbox-scrollbar-width");
            }
        });
        
    } catch(e) {
        
        window.addEventListener('resize', VutBox.resize);
        
    }
    
})();